import React from "react";
import { Link } from "react-router-dom";
import { ScrollToTopOnMount } from "../../../Components/ScrollToTop/ScrollToTop";
import SVGIcons from "../../../assets/images/icons/svgIcons";
import "./terms.scss";



const PrivacyPolicy = () => {
    ScrollToTopOnMount();

    return (
        <div className="page-main-wrapper privacy-main-wrapper f-wrp">
            <div className="container">
                <div className="breadcrumb f-wrp">
                    <Link to={'/'}> Home &nbsp;&nbsp;<SVGIcons.RightChevronIcon /></Link>&nbsp;
                    <p>Privacy Policy</p>
                </div>
                <div className="TC-policy-wrp f-wrp">
                    <h1 className="main-header">Privacy Policy</h1>
                    <br />
                    <br />
                    <p>Last Updated: 12-march-2025</p>
                    <br />
                    <p>This Privacy Policy describes how Propshop Real Estate LLC ("we," "us," or "our") collects, uses, and shares information about you when you use our website www.propshop.ai (the "Site"). We are committed to protecting your privacy and ensuring the security of your personal information.</p>
                    <br />
                    <h4>1. Information We Collect</h4>
                    <br />
                    <p>We may collect the following types of information: </p>
                    <br />
                    <ul>
                        <li>Information You Provide Directly:</li>
                        <br />
                        <ul>
                            <li>Contact information: Name, email address, phone number, and postal address.</li>
                            <li>Property search criteria: Desired location, price range, property type, and other preferences.</li>
                            <li>Financial information: (If applicable) Information related to mortgage pre-approval or financing applications.</li>
                            <li>Information provided when scheduling showings or open house visits.</li>
                            <li>Any information you provide when contacting us through forms, email, or phone.</li>
                        </ul>
                        <br />
                        <li>Information Collected Automatically:</li>
                        <br />
                        <ul>
                            <li>Log data: IP address, browser type, operating system, referring URLs, and pages viewed.</li>
                            <li>Cookies and similar technologies: Information about your browsing activities on our Site.</li>
                            <li>Location data: (If applicable) Information about your location when using our property search features.</li>
                            <li>Analytics data: Information about how you interact with our website.</li>
                        </ul>
                    </ul>
                    <br />
                    <h4>2. How We Use Your Information</h4>
                    <br />
                    <p>We may use your information for the following purposes:</p>
                    <br />
                    <ul>
                        <li>To provide and maintain the Site and its features.</li>
                        <li>To match you with properties that meet your search criteria.</li>
                        <li>To facilitate communication between you and our real estate agents.</li>
                        <li>To schedule property showings and open house visits.</li>
                        <li>To process mortgage pre-approval or financing applications (if applicable).</li>
                        <li>To provide market analysis and property reports.</li>
                        <li>To respond to your inquiries and provide customer support.</li>
                        <li>To send you updates, newsletters, and marketing materials (with your consent).</li>
                        <li>To analyze and improve the Site's performance and user experience.</li>
                        <li>To comply with legal and regulatory obligations.</li>
                    </ul>
                    <br />
                    <h4>3. Sharing Your Information</h4>
                    <br />
                    <p>We may share your information with:</p>
                    <br />
                    <ul>
                        <li>Real Estate Agents and Brokers: To facilitate property transactions and communication.</li>
                        <li>Multiple Listing Services (MLS): To access and display property listings.</li>
                        <li>Third-Party Service Providers: Including website hosting, payment processors, analytics providers, and marketing platforms.</li>
                        <li>Title Companies, Escrow Services, Appraisers, and Inspectors: As necessary to facilitate real estate transactions.</li>
                        <li>Lead Generation Partners: with explicit consent.</li>
                        <li>Legal Authorities: When required by law or to protect our rights.</li>
                        <li>Business Transfers: In the event of a merger, acquisition, or sale of assets. </li>
                    </ul>
                    <br />
                    <h4>4. Your Choices</h4>
                    <br />
                    <ul>
                        <li>Cookies: You can control cookies through your browser settings.</li>
                        <li>Marketing Communications: You can opt out of receiving marketing emails by following the unsubscribe instructions in the emails.</li>
                        <li>Access and Correction: You can request to access, correct, or delete your personal information by contacting us at <a style={{ color: 'inherit' }} href="mailto:admin@propshop.ai">admin@propshop.ai</a>.</li>
                    </ul>
                    <br />
                    <h4>5. Security</h4>
                    <br />
                    <p>We take reasonable measures to protect your information from unauthorized access, use, or disclosure. However, no method of transmission over the Internet or electronic storage is completely secure.</p>
                    <br />
                    <h4>6. Children's Privacy</h4>
                    <br />
                    <p>Our Site is not intended for children under the age of 18. We do not knowingly collect personal information from children under 18. If you are a parent or guardian and believe that your child has provided us with personal information, please contact us. </p>
                    <br />
                    <h4>7. Changes to This Privacy Policy</h4>
                    <br />
                    <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes.  </p>
                    <br />
                    <h4>8. Contact Us</h4>
                    <br />
                    <p>If you have any questions about this Privacy Policy, please contact us at:</p>
                    <br />
                    <p style={{ lineHeight: '1.6' }}>
                        Propshop Real Estate LLC,<br />
                        Office 1914-170,<br />
                        The Binary by Omniyat,<br />
                        Business Bay.<br />
                        <a style={{ color: 'inherit' }} href="mailto:admin@propshop.ai">admin@propshop.ai</a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
